import React from 'react';
import Hero from '../../components/Hero/Hero';
import Features from '../../components/Features/Features';
// import HowItWorks from '../../components/HowItWorks/HowItWorks';
import FeatureOverview from '../../components/FeatureOverview/FeatureOverview';
// import Pricing from '../../components/Pricing/Pricing';
// import Library from '../../components/Library/Library';

const LandingPage = () => {
  return (
    <>
      <Hero />
      <Features />
      <FeatureOverview />
      {/* <section id="pricing-section">
        <Pricing />
      </section> */}
      {/* <Library /> */}
    </>
  );
};

export default LandingPage;